"use client";

import { useEffect } from "react";

export function InertFix() {
  useEffect(() => {
    const observer = new MutationObserver(() => {
      for (const element of document.querySelectorAll(
        "body > :has(> [role=dialog][class*=popover])",
      )) {
        if (element instanceof HTMLElement && element.inert) {
          element.inert = false;
        }
      }
    });

    observer.observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ["inert"],
    });

    return () => observer.disconnect();
  }, []);

  return <></>;
}
